import axios from "axios";
import { atom } from "jotai";
import { SetStateAction } from "jotai/core/types";
import { atomFamily } from "jotai/utils";

import { MatchUpType, RoundType } from "./widget.types";

export const matchUpGameAtom = atom<MatchUpType, SetStateAction<MatchUpType>>(
  async () => {
    try {
      const submission = window.theme.Sweepstake.prototype.retrieveSubmission();
      const { data }: { data: MatchUpType } = await axios.get(
        `${
          window.FKL.yentaServicesApiUrl
        }/matchup/${window.FKL.matchUpSlug.trim()}`
      );

      if (submission) {
        const lastRoundPlayedIndex = data.rounds.findIndex(
          (round) => round.id === submission.data.lastMatchUpRoundId
        );

        if (
          lastRoundPlayedIndex >= 0 &&
          lastRoundPlayedIndex < data.rounds.length - 1
        ) {
          data.rounds = data.rounds.slice(
            lastRoundPlayedIndex + 1,
            data.rounds.length
          );
        }

        data.allTimePoints = Number(submission.data.quizExtraEntries);
      } else {
        data.allTimePoints = 0;
      }

      const emailReceiver = (submission?.data.email || "") as string;

      return {
        ...data,
        rounds: data.rounds.map((round) => ({
          ...round,
          isFinalized: false,
          pairs: round.pairs
            .filter((pair) => pair.imageLink != null)
            .map((pair, index) => ({
              ...pair,
              name: `${round.brandName}-pair-${index}`,
              isMatched: false,
              mainIndex: index,
            })),
          cpl: {
            ...round.cpl,
            emailReceiver,
            registeredCpl: false,
            isAccepted: null,
          },
        })),
      } as MatchUpType;
    } catch (error) {
      throw new Error(error.response?.data?.message ?? error.message);
    }
  },
  (get, set, update) => {
    const newValue =
      typeof update === "function" ? update(get(matchUpGameAtom)) : update;
    set(matchUpGameAtom, newValue);
  }
);

export const currentRoundIndexAtom = atom<number>(0);

export const currentRoundAtom = atomFamily<
  string,
  RoundType,
  SetStateAction<RoundType>
>((id) =>
  atom(
    (get) => {
      const rounds = get(matchUpGameAtom)?.rounds ?? [];
      const round = rounds.find((round) => round.id === id);

      if (!round) {
        throw new Error(`Round id: ${id} does not exist`);
      }

      return round;
    },
    (_get, set, update) => {
      set(matchUpGameAtom, (matchUp) => ({
        ...matchUp,
        rounds: matchUp.rounds.map((round) =>
          round.id !== id
            ? round
            : typeof update === "function"
            ? update(round)
            : update
        ),
      }));
    }
  )
);
